const dateTimeFmt = new Intl.DateTimeFormat('de-DE', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
});

const dateFmt = new Intl.DateTimeFormat('de-DE', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
});

const dateTimeShortFmt = new Intl.DateTimeFormat('de-DE', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
});

const timeFmt = new Intl.DateTimeFormat('de-DE', {
    hour: '2-digit',
    minute: '2-digit',
});

const timeWithSecondsFmt = new Intl.DateTimeFormat('de-DE', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
});

function toDate(value: Date | string | number | null | undefined): Date | null {
    if (value == null) return null;
    if (value instanceof Date) return isNaN(value.getTime()) ? null : value;
    const d = new Date(value);
    return isNaN(d.getTime()) ? null : d;
}

export function formatDateTime(value: Date | string | number | null | undefined, fallback = '--'): string {
    const d = toDate(value);
    return d ? dateTimeFmt.format(d) : fallback;
}

export function formatDateTimeShort(value: Date | string | number | null | undefined, fallback = '--'): string {
    const d = toDate(value);
    return d ? dateTimeShortFmt.format(d) : fallback;
}

export function formatDate(value: Date | string | number | null | undefined, fallback = '--'): string {
    const d = toDate(value);
    return d ? dateFmt.format(d) : fallback;
}

// <input type="date"> speaks local calendar days. Going through toISOString() instead moves the day
// for anyone east of UTC, which is everybody here.
export function toDateInput(value: Date | string | number | null | undefined): string {
    const d = toDate(value);
    if (!d) return '';
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export function fromDateInput(value: string): Date | null {
    const [year, month, day] = value.split('-').map(Number);
    if (!year || !month || !day) return null;
    return new Date(year, month - 1, day);
}

// <input type="datetime-local"> wants "YYYY-MM-DDTHH:mm" and reads it back as local time, same as the
// date-only pair above.
export function toDateTimeInput(value: Date | string | number | null | undefined): string {
    const d = toDate(value);
    if (!d) return '';
    const time = `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
    return `${toDateInput(d)}T${time}`;
}

export function fromDateTimeInput(value: string): Date | null {
    return toDate(value ? new Date(value) : null);
}

export function formatTime(value: Date | string | number | null | undefined, fallback = '--', withSeconds = false): string {
    const d = toDate(value);
    if (!d) return fallback;
    return (withSeconds ? timeWithSecondsFmt : timeFmt).format(d);
}
